import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { ActivitiesComponent } from './activities.component';
import { PreventDuplicatePipe } from './prevent-duplicate.pipe';
import { MergeExperiencesPipe } from './merge-experiences.pipe.ts';

const MODULES = [
  CommonModule,
  MatRippleModule,
  MatIconModule,
  TranslateModule
];

const COMPONENTS = [
  ActivitiesComponent
];

const PIPES = [
  PreventDuplicatePipe,
  MergeExperiencesPipe
];

@NgModule({
  imports: [
    MODULES
  ],
  declarations: [
    COMPONENTS,
    PIPES
  ],
  exports: [
    ActivitiesComponent
  ]
})
export class ActivitiesModule { }
